import { Plan } from "@/types";
import { isEqual, pick } from "lodash";

/**
 * Selects variants (yearly and monthly) of the same plan
 */
export const getPlanVariants = (selectedPlan: Plan, plans: Plan[]) => {
  const compareFields = ["tasks", "name", "zaps", "description"];
  return plans.filter((p) =>
    isEqual(pick(p, compareFields), pick(selectedPlan, compareFields))
  );
};
